export default __webpack_public_path__ + "static/media/fundsize-icon.d851d4ae.svg";